import React from 'react';
import { Button, Theme } from '@havenengineering/module-shared-library/dist/components/Button';
import clsx from 'clsx';
import styles from './PopUp.module.scss';
import { Alert } from '../Alert';
export const PopUp = ({ title, description, children, submitBtnText, alert, handleClose, handleSubmit, submitDisabled = false, }) => {
    const displayButton = Boolean(submitBtnText && handleSubmit);
    return (<div className={styles.popUpWrapper}>
      <div className={styles.popUpContainer}>
        <Button onClick={handleClose} className={styles.closeBtn}>
          <img alt='close' src='https://www.haven.com/assets/icons/cross.svg' width={32} height={32}/>
        </Button>
        <div className={clsx(styles.popUpContent, {
            [styles.withSubmitButton]: displayButton,
        })}>
          {alert ? (<Alert severity={alert.severity} className={styles.alert}>
              {alert.message}
            </Alert>) : null}
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
          {children}
        </div>
        {displayButton ? (<Button onClick={handleSubmit} disabled={submitDisabled} theme={Theme.PRIMARY_THEME} block>
            {submitBtnText}
          </Button>) : null}
      </div>
    </div>);
};
